import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@storable/canaveral-components';
import { Form } from 'react-bootstrap';
import {
  OPTION_IFRAME,
  OPTION_LINKOUT,
  OPTION_NAME,
} from '../../../../../../website/widgets/dynamic/PayOnline/properties';

const propTypes = {
  input: PropTypes.shape({
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
  }),
  payOption: PropTypes.string,
};

const Editor = ({ input }) => {
  const onRadioChange = e => input.onChange(e.target.value);

  const { value } = input;
  const sLWarning = 'The settings below only control storEDGE facilities. All SiteLink facilities will link out to Tenant Portal in a new tab.'; // eslint-disable-line max-len

  return (
    <React.Fragment>
      <Alert context="primary">
        {sLWarning}
      </Alert>
      <Form.Group>
        <Form.Check
          id="pay-online-iframe"
          type="radio"
          checked={value === OPTION_IFRAME}
          name={OPTION_NAME}
          value={OPTION_IFRAME}
          onChange={onRadioChange}
          label="Embed Tenant Portal"
        />
        <Form.Text>
          Opens the tenant portal login on page
        </Form.Text>
        <Form.Check
          id="pay-online-linkout"
          type="radio"
          checked={value === OPTION_LINKOUT}
          name={OPTION_NAME}
          value={OPTION_LINKOUT}
          onChange={onRadioChange}
          label="Link Out to Tenant Portal"
        />
        <Form.Text>
          Opens the tenant portal login in a new tab
        </Form.Text>
      </Form.Group>
    </React.Fragment>
  );
};

Editor.propTypes = propTypes;

export default Editor;
